export default {"src":"/_next/static/media/No-Image-Placeholder.e9a29303.svg","height":574,"width":574,"blurWidth":0,"blurHeight":0};